var _path, _g, _path2, _g2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudsIconCitron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 68,
    viewBox: "0 0 128 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_242_52194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 68
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0410156 0.653076H127.166V67.9596H0.0410156V0.653076Z",
    fill: "#E6F972"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_242_52194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.91 68.0001H69.3204C69.3049 68.0001 69.29 67.9994 69.2745 67.9994C62.4255 67.9745 56.4721 63.2125 54.7343 56.4017C54.5505 55.6806 54.9878 54.9481 55.7117 54.765C56.4376 54.5825 57.171 55.0175 57.3548 55.7379C58.7918 61.3724 63.6962 65.307 69.2812 65.307H110.473C110.572 65.2733 110.676 65.2504 110.785 65.2403C118.582 64.5119 124.462 57.7893 124.462 49.603C124.462 41.4531 118.374 34.5777 110.601 33.9509C110.101 33.9105 109.664 33.5975 109.467 33.1383C106.406 26.0037 99.591 21.3945 92.1053 21.3945C87.8694 21.3945 83.8612 22.8164 80.5148 25.5075C79.9329 25.9754 79.0819 25.8838 78.6135 25.3062C78.1444 24.7272 78.2357 23.8795 78.8163 23.4123C82.6493 20.33 87.2448 18.7014 92.1053 18.7014C100.416 18.7014 107.995 23.6405 111.625 31.3508C120.403 32.4825 127.166 40.3422 127.166 49.603C127.166 59.0322 120.454 66.8077 111.481 67.8748C111.308 67.955 111.115 68.0001 110.91 68.0001Z",
    fill: "#E6F972"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_242_52194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 68
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0410156 0.653076H127.166V67.9596H0.0410156V0.653076Z",
    fill: "#E6F972"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_242_52194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7709 15.3249C62.5796 6.38527 53.7603 0.653076 44.0861 0.653076C31.9589 0.653076 21.5486 9.6486 19.3357 21.795C18.6841 21.7189 18.0285 21.6799 17.3769 21.6799C7.79524 21.6799 0 29.7073 0 39.5747C0 49.4205 7.76077 57.4351 17.3701 57.4681C17.3877 57.4688 17.4053 57.4694 17.4229 57.4694H66.0916C66.3079 57.4694 66.5113 57.4189 66.6925 57.3294C77.0967 56.1216 84.8839 47.1752 84.8839 36.3214C84.8839 25.6306 76.9913 16.5657 66.7709 15.3249Z",
    fill: "#E6F972"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1482 30.9434C37.8205 30.9434 39.1762 29.5929 39.1762 27.9271C39.1762 26.2613 37.8205 24.9109 36.1482 24.9109C34.4758 24.9109 33.1201 26.2613 33.1201 27.9271C33.1201 29.5929 34.4758 30.9434 36.1482 30.9434Z",
    fill: "#01313D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2605 30.9434C49.9328 30.9434 51.2886 29.5929 51.2886 27.9271C51.2886 26.2613 49.9328 24.9109 48.2605 24.9109C46.5881 24.9109 45.2324 26.2613 45.2324 27.9271C45.2324 29.5929 46.5881 30.9434 48.2605 30.9434Z",
    fill: "#01313D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3829 36.7615C47.3118 36.7615 50.9331 38.9658 53.0095 43.2526C53.3728 44.0028 53.0569 44.9043 52.3038 45.2662C51.5507 45.6281 50.6456 45.3134 50.2822 44.5632C48.7173 41.3323 46.1633 39.7777 42.3829 39.7777C38.6024 39.7777 36.0484 41.3323 34.4835 44.5632C34.1201 45.3134 33.2151 45.6281 32.4619 45.2662C31.7088 44.9043 31.3929 44.0028 31.7562 43.2526C33.8326 38.9658 37.454 36.7615 42.3829 36.7615Z",
    fill: "#01313D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsIconCitron);
export default __webpack_public_path__ + "static/media/clouds-icon-citron.4d83c8f37c7e737fe961438542cd0dc6.svg";
export { ForwardRef as ReactComponent };